import {
  VENDOR_INCOME_EXPENSE_FETCHING,
  VENDOR_INCOME_EXPENSE_FAILED,
  VENDOR_INCOME_EXPENSE_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case VENDOR_INCOME_EXPENSE_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case VENDOR_INCOME_EXPENSE_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case VENDOR_INCOME_EXPENSE_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
